var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fill-height":"","fluid":""}},[_c('div',{attrs:{"id":"map"}}),(_vm.isLoading)?_c('loader'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }